"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var HideContactFloatElement = /** @class */ (function () {
    function HideContactFloatElement() {
        var _this = this;
        this.contactFloat = document.querySelector("[".concat(constants_1.DATA_CONTACT_FLOAT, "]"));
        this.contactPerson = document.querySelector("[".concat(constants_1.DATA_CONTACT_PERSON, "]"));
        if (!this.contactFloat) {
            return;
        }
        window.addEventListener('scroll', function () {
            _this.hideContactFloat(_this.contactPerson);
        });
    }
    HideContactFloatElement.prototype.hideContactFloat = function (elem) {
        if (this.isInViewport(elem)) {
            this.contactFloat.classList.add('hidden');
        }
        else {
            if (this.contactFloat) {
                this.contactFloat.classList.remove('hidden');
            }
        }
    };
    HideContactFloatElement.prototype.isInViewport = function (elem) {
        if (this.contactFloat) {
            var rect = elem.getBoundingClientRect();
            return (rect.top <= ((window.innerHeight || document.documentElement.clientHeight)));
        }
    };
    return HideContactFloatElement;
}());
exports.default = HideContactFloatElement;
